"use strict";

jQuery.feature('js-input-number-count', function (el) {

    $(el).on("input", function (e) {
        e.target.value = e.target.value.replace(/[^0-9]/g, '')
    });
});
